var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ModalData",
    {
      class: `modal-basemap-${_vm.basemapType}`,
      attrs: {
        size: "large",
        title: _vm.modalTitle,
        show: _vm.show,
        needHeader: true,
        needFooter: true,
        relativeBackdrop: false,
        contentCentered: true,
        saveButton: _vm.saveButtonCfg,
      },
      on: { close: _vm.onClose, save: _vm.onSave },
    },
    [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-sm-12" },
          [
            _c(_vm.basemapComponent, {
              tag: "component",
              attrs: {
                panelID: _vm.pageID,
                basemapUrl: _vm.basemapUrl,
                basemapItems: _vm.basemapItems,
                readonlyFormItem: _vm.readonlyFormItem,
                keyChilds: _vm.keyChilds,
                keyGroup: _vm.keyGroup,
              },
              on: { selected: _vm.onSelectedItem },
              model: {
                value: _vm.form,
                callback: function ($$v) {
                  _vm.form = $$v
                },
                expression: "form",
              },
            }),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }